export default "__VITE_ASSET__BZ2eAgi8__"